import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modalRoot",
    "modal",
  ]

  connect() {
    this.element.addEventListener('turbo:submit-end', (e) => {
      if (e.detail.success) {
        this.closeModal()
      }
    })

    this.element.addEventListener('datachange', (e) => {
      console.log('datachanged', e)
    })
  }

  showModal(){
    this.element.dataset.isOpen = true

    this.modalTarget.classList.add("-translate-y-full")

    if (this.hasModalRootTarget){
      this.modalRootTarget.focus({ preventScroll: true })
      this.modalRootTarget.addEventListener('keydown', (e) => {
        if (e.code !== 'Escape') return
        this.closeModal()
      })
    }

    setTimeout(() => {
      this.modalTarget.classList.remove("-translate-y-full")
      this.modalTarget.classList.add(
        "duration-300",
        "ease-in-out",
        "transform",
        "transition",
        "translate-y-0",
      )
    }, 50)
  }

  closeModal(){
    this.element.dataset.isOpen = false

    this.slideOut()
  }

  slideOut() {
    this.modalTarget.classList.remove("translate-y-0")
    this.modalTarget.classList.add(
      "duration-300",
      "ease-in-out",
      "transform",
      "transition",
      "-translate-y-full",
    )
  }
}
